import React, { useContext, useEffect } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import {geocodeByAddress,getLatLng} from 'react-places-autocomplete';
import { CategoriasContext } from '../../context/categorias/categoriasContext';
import { OperacionesContext } from '../../context/operaciones/operacionesContext';
import { PartidosContext } from '../../context/partidos/partidosContext';
import { LocalidadesContext } from '../../context/localidades/localidadesContext';
import { BarriosContext } from "../../context/barrios/barriosContext";
import Loader from '../Loader/Loader';
import ThumbnailUpload from '../ThumbnailUpload';

const FormPropiedad = (props) => {
    const {handleChange,formValues,setFormValues,allFormValues} = props;

    const {data:categorias,traerTodas:traerCategorias} = useContext(CategoriasContext);
    const {data:operaciones,traerTodas:traerOperaciones} = useContext(OperacionesContext);
    const {data:partidos,traerTodos:traerPartidos} = useContext(PartidosContext);
    const {data:localidades,filtradas:localidadesFiltradas,traerTodas:traerLocalidades,filtrarPorIdPartido:filtrarLocalidades} = useContext(LocalidadesContext);
    const {data:barrios,filtrados:barriosFiltrados,traerTodos:traerBarrios,filtrarPorIdLocalidad:filtrarBarrios} = useContext(BarriosContext);

    useEffect(() => {
        getResources();
    }, [])

    const getResources = async()=>{
        if(!categorias.length){
            await traerCategorias();
        }
        if(!operaciones.length){
            await traerOperaciones();
        }
        if(!partidos.length){
            await traerPartidos();
        }
        if(!localidades.length){
            await traerLocalidades();
        }
        if(!barrios.length){
            await traerBarrios();
        }
    }

    const handleSelectUbicacion = address => {
        geocodeByAddress(address).then(results => getLatLng(results[0])).then(latLng =>{
            setFormValues({
                ...allFormValues,
                propiedad:{
                    ...allFormValues.propiedad,
                    direccion:address,
                    lat:latLng.lat,
                    lon:latLng.lng
                }
            });
        })
        .catch(error => console.error('Error', error));
    };
    const handleChangeUbicacion = address => {
        handleChange({
            target:{
                name:"direccion",
                value:address
            },
        });
    };

    const handleChangePartido = e => {
        filtrarLocalidades(e.target.value);
        handleChange(e);
    };

    const handleChangeLocalidad = e =>{
        filtrarBarrios(e.target.value);
        handleChange(e);
    }

    console.log(formValues);
    

    return(
        !categorias.length || !operaciones.length || !partidos.length || !localidades.length || !barrios.length || (props.id && formValues.idCategoria=='')  ? <Loader/> :
        <div className="form-group" id="form-principal">
            <h6>Datos principales:</h6>
            <div className="row">
                <div className="col-12 col-md-6 my-2">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">
                                Categoria
                            </div>
                        </div>
                        <select name="idCategoria" className="form-control" onChange={handleChange} defaultValue={formValues.idCategoria}>
                            <option value="">Selecciona una categoria</option>
                            {categorias.map(categoria=>(
                                <option key={categoria.id} value={categoria.id}>{categoria.categoria}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-12 col-md-6 my-2">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">
                                Tipo de operación
                            </div>
                        </div>
                        <select name="idOperacion" className="form-control" onChange={handleChange} defaultValue={formValues.idOperacion}>
                            <option value="">Selecciona el tipo operacion</option>
                            {operaciones.map(operacion=>(
                                <option key={operacion.id} value={operacion.id}>{operacion.operacion}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-12 col-md-4 my-2">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">
                                Partido
                            </div>
                        </div>
                        <select name="idPartido" className="form-control" onChange={handleChangePartido} defaultValue={formValues.idPartido}>
                            <option value="">Selecciona un partido</option>
                            {partidos.map(partido=>(
                                <option key={partido.id} value={partido.id}>{partido.partido}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-12 col-md-4 my-2">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">
                                Localidad
                            </div>
                        </div>
                        <select name="idLocalidad" className="form-control" onChange={handleChangeLocalidad} defaultValue={formValues.idLocalidad}>
                            <option value="">Selecciona localidad</option>
                            {localidadesFiltradas.map(localidad=>(
                                <option key={localidad.id} value={localidad.id}>{localidad.localidad}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-12 col-md-4 my-2">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">
                                Barrio
                            </div>
                        </div>
                        <select name="idBarrio" className="form-control" onChange={handleChange} defaultValue={formValues.idBarrio}>
                            <option value="">Selecciona barrio</option>
                            {barriosFiltrados.map(barrio=>(
                                <option key={barrio.idBarrio} value={barrio.idBarrio}>{barrio.barrio}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="col-12 my-2">
                    <label>Dirección:</label>
                    <PlacesAutocomplete value={formValues.direccion} onChange={handleChangeUbicacion} onSelect={handleSelectUbicacion} autocomplete="false">
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div>
                            <input
                                className='form-control' id="ubicacion"
                                {...getInputProps({ 
                                    placeholder: 'Buscá tu dirección ...',
                                })}
                            />
                            <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map((suggestion,key) => {
                                    const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                    ? { backgroundColor: '#fafafa', cursor: 'pointer',margin:'10px',padding:'5px' }
                                    : { backgroundColor: '#ffffff', cursor: 'pointer',margin:'10px',padding:'5px' };
                                    return (
                                        <div
                                            {...getSuggestionItemProps(suggestion, {
                                            className,
                                            style,
                                            key
                                            })}
                                        >
                                            <span>{suggestion.description}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    </PlacesAutocomplete>
                </div>
            </div>
            <textarea name="descripcion" className="form-control my-2" placeholder="Describa la propiedad" cols="30" rows="10" onChange={handleChange} defaultValue={formValues.descripcion}></textarea>
            <div className="row">
                <div className="col-12 col-md-6 my-2">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">
                                Precio
                            </div>
                        </div>
                        <input value={formValues.precio} type="text" name="precio" placeholder="Precio" className="form-control" onChange={handleChange}/>
                    </div>
                </div>
                <div className="col-12 col-md-6 my-2">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">
                                Estado
                            </div>
                        </div>
                        <select required name="estado" className="form-control" id="" onChange={handleChange} defaultValue={formValues.estado}>
                            <option value="Disponible">Disponible</option>
                            <option value="Ocupado">Ocupado</option>
                            <option value="Reservado">Reservado</option>
                            <option value="Alquilado">Alquilado</option>
                            <option value="Vendido">Vendido</option>
                        </select>
                    </div>
                </div>
                <div className="col-12 col-md-6 input-group my-2">
                    <div className="input-group-prepend">
                        <div className="input-group-text">
                            Mostrar Estado en la publicación
                        </div>
                    </div>
                    <select required name="mostrarEstado" className="form-control" id="" onChange={handleChange} defaultValue={formValues.mostrarEstado}>
                        <option value="si">Si</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <div className="col-12 col-md-6 my-2">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text">
                                Moneda
                            </div>
                        </div>
                        <select required name="moneda" className="form-control" id="" onChange={handleChange} defaultValue={formValues.moneda}>
                            <option value="dolar">Dolar</option>
                            <option value="pesos">Pesos</option>
                        </select>
                    </div>
                </div>
            </div>
            <br/>
        </div>
    );
}
 
export default FormPropiedad;